import { jsx as Y, jsxs as Xt } from "react/jsx-runtime";
import * as z from "react";
import { useRef as qt, useState as $t, useCallback as pn, useEffect as Pt } from "react";
import { c as ht } from "../clsx-OuTLNxxd.js";
import { B as Yt } from "../Button-BrO5Axzv.js";
import { c as Zt } from "../createLucideIcon-WU3cnAkb.js";
import '../Carousel.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gn = Zt("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = Zt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
function yn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Kt(t) {
  return yn(t) || Array.isArray(t);
}
function Sn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function _t(t, n) {
  const r = Object.keys(t), s = Object.keys(n);
  if (r.length !== s.length) return !1;
  const i = JSON.stringify(Object.keys(t.breakpoints || {})), e = JSON.stringify(Object.keys(n.breakpoints || {}));
  return i !== e ? !1 : r.every((o) => {
    const l = t[o], c = n[o];
    return typeof l == "function" ? `${l}` == `${c}` : !Kt(l) || !Kt(c) ? l === c : _t(l, c);
  });
}
function Ut(t) {
  return t.concat().sort((n, r) => n.name > r.name ? 1 : -1).map((n) => n.options);
}
function xn(t, n) {
  if (t.length !== n.length) return !1;
  const r = Ut(t), s = Ut(n);
  return r.every((i, e) => {
    const o = s[e];
    return _t(i, o);
  });
}
function Tt(t) {
  return typeof t == "number";
}
function wt(t) {
  return typeof t == "string";
}
function bt(t) {
  return typeof t == "boolean";
}
function Qt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function _(t) {
  return Math.abs(t);
}
function At(t) {
  return Math.sign(t);
}
function dt(t, n) {
  return _(t - n);
}
function bn(t, n) {
  if (t === 0 || n === 0 || _(t) <= _(n)) return 0;
  const r = dt(_(t), _(n));
  return _(r / t);
}
function Cn(t) {
  return Math.round(t * 100) / 100;
}
function mt(t) {
  return pt(t).map(Number);
}
function H(t) {
  return t[yt(t)];
}
function yt(t) {
  return Math.max(0, t.length - 1);
}
function Dt(t, n) {
  return n === yt(t);
}
function Jt(t, n = 0) {
  return Array.from(Array(t), (r, s) => n + s);
}
function pt(t) {
  return Object.keys(t);
}
function Wt(t, n) {
  return [t, n].reduce((r, s) => (pt(s).forEach((i) => {
    const e = r[i], o = s[i], l = Qt(e) && Qt(o);
    r[i] = l ? Wt(e, o) : o;
  }), r), {});
}
function Ot(t, n) {
  return typeof n.MouseEvent < "u" && t instanceof n.MouseEvent;
}
function vn(t, n) {
  const r = {
    start: s,
    center: i,
    end: e
  };
  function s() {
    return 0;
  }
  function i(c) {
    return e(c) / 2;
  }
  function e(c) {
    return n - c;
  }
  function o(c, a) {
    return wt(t) ? r[t](c) : t(n, c, a);
  }
  return {
    measure: o
  };
}
function gt() {
  let t = [];
  function n(i, e, o, l = {
    passive: !0
  }) {
    let c;
    if ("addEventListener" in i)
      i.addEventListener(e, o, l), c = () => i.removeEventListener(e, o, l);
    else {
      const a = i;
      a.addListener(o), c = () => a.removeListener(o);
    }
    return t.push(c), s;
  }
  function r() {
    t = t.filter((i) => i());
  }
  const s = {
    add: n,
    clear: r
  };
  return s;
}
function In(t, n, r, s) {
  const i = gt(), e = 1e3 / 60;
  let o = null, l = 0, c = 0;
  function a() {
    i.add(t, "visibilitychange", () => {
      t.hidden && d();
    });
  }
  function y() {
    S(), i.clear();
  }
  function m(h) {
    if (!c) return;
    o || (o = h, r(), r());
    const f = h - o;
    for (o = h, l += f; l >= e; )
      r(), l -= e;
    const g = l / e;
    s(g), c && (c = n.requestAnimationFrame(m));
  }
  function u() {
    c || (c = n.requestAnimationFrame(m));
  }
  function S() {
    n.cancelAnimationFrame(c), o = null, l = 0, c = 0;
  }
  function d() {
    o = null, l = 0;
  }
  return {
    init: a,
    destroy: y,
    start: u,
    stop: S,
    update: r,
    render: s
  };
}
function En(t, n) {
  const r = n === "rtl", s = t === "y", i = s ? "y" : "x", e = s ? "x" : "y", o = !s && r ? -1 : 1, l = y(), c = m();
  function a(d) {
    const {
      height: p,
      width: h
    } = d;
    return s ? p : h;
  }
  function y() {
    return s ? "top" : r ? "right" : "left";
  }
  function m() {
    return s ? "bottom" : r ? "left" : "right";
  }
  function u(d) {
    return d * o;
  }
  return {
    scroll: i,
    cross: e,
    startEdge: l,
    endEdge: c,
    measureSize: a,
    direction: u
  };
}
function ot(t = 0, n = 0) {
  const r = _(t - n);
  function s(a) {
    return a < t;
  }
  function i(a) {
    return a > n;
  }
  function e(a) {
    return s(a) || i(a);
  }
  function o(a) {
    return e(a) ? s(a) ? t : n : a;
  }
  function l(a) {
    return r ? a - r * Math.ceil((a - n) / r) : a;
  }
  return {
    length: r,
    max: n,
    min: t,
    constrain: o,
    reachedAny: e,
    reachedMax: i,
    reachedMin: s,
    removeOffset: l
  };
}
function tn(t, n, r) {
  const {
    constrain: s
  } = ot(0, t), i = t + 1;
  let e = o(n);
  function o(u) {
    return r ? _((i + u) % i) : s(u);
  }
  function l() {
    return e;
  }
  function c(u) {
    return e = o(u), m;
  }
  function a(u) {
    return y().set(l() + u);
  }
  function y() {
    return tn(t, l(), r);
  }
  const m = {
    get: l,
    set: c,
    add: a,
    clone: y
  };
  return m;
}
function Ln(t, n, r, s, i, e, o, l, c, a, y, m, u, S, d, p, h, f, g) {
  const {
    cross: x,
    direction: I
  } = t, N = ["INPUT", "SELECT", "TEXTAREA"], E = {
    passive: !1
  }, C = gt(), v = gt(), L = ot(50, 225).constrain(S.measure(20)), A = {
    mouse: 300,
    touch: 400
  }, P = {
    mouse: 500,
    touch: 600
  }, M = d ? 43 : 25;
  let R = !1, j = 0, G = 0, tt = !1, Z = !1, K = !1, U = !1;
  function it(b) {
    if (!g) return;
    function w(V) {
      (bt(g) || g(b, V)) && lt(V);
    }
    const D = n;
    C.add(D, "dragstart", (V) => V.preventDefault(), E).add(D, "touchmove", () => {
    }, E).add(D, "touchend", () => {
    }).add(D, "touchstart", w).add(D, "mousedown", w).add(D, "touchcancel", B).add(D, "contextmenu", B).add(D, "click", J, !0);
  }
  function q() {
    C.clear(), v.clear();
  }
  function rt() {
    const b = U ? r : n;
    v.add(b, "touchmove", k, E).add(b, "touchend", B).add(b, "mousemove", k, E).add(b, "mouseup", B);
  }
  function st(b) {
    const w = b.nodeName || "";
    return N.includes(w);
  }
  function Q() {
    return (d ? P : A)[U ? "mouse" : "touch"];
  }
  function ut(b, w) {
    const D = m.add(At(b) * -1), V = y.byDistance(b, !d).distance;
    return d || _(b) < L ? V : h && w ? V * 0.5 : y.byIndex(D.get(), 0).distance;
  }
  function lt(b) {
    const w = Ot(b, s);
    U = w, K = d && w && !b.buttons && R, R = dt(i.get(), o.get()) >= 2, !(w && b.button !== 0) && (st(b.target) || (tt = !0, e.pointerDown(b), a.useFriction(0).useDuration(0), i.set(o), rt(), j = e.readPoint(b), G = e.readPoint(b, x), u.emit("pointerDown")));
  }
  function k(b) {
    if (!Ot(b, s) && b.touches.length >= 2) return B(b);
    const D = e.readPoint(b), V = e.readPoint(b, x), $ = dt(D, j), X = dt(V, G);
    if (!Z && !U && (!b.cancelable || (Z = $ > X, !Z)))
      return B(b);
    const nt = e.pointerMove(b);
    $ > p && (K = !0), a.useFriction(0.3).useDuration(0.75), l.start(), i.add(I(nt)), b.preventDefault();
  }
  function B(b) {
    const D = y.byDistance(0, !1).index !== m.get(), V = e.pointerUp(b) * Q(), $ = ut(I(V), D), X = bn(V, $), nt = M - 10 * X, W = f + X / 50;
    Z = !1, tt = !1, v.clear(), a.useDuration(nt).useFriction(W), c.distance($, !d), U = !1, u.emit("pointerUp");
  }
  function J(b) {
    K && (b.stopPropagation(), b.preventDefault(), K = !1);
  }
  function F() {
    return tt;
  }
  return {
    init: it,
    destroy: q,
    pointerDown: F
  };
}
function Nn(t, n) {
  let s, i;
  function e(m) {
    return m.timeStamp;
  }
  function o(m, u) {
    const d = `client${(u || t.scroll) === "x" ? "X" : "Y"}`;
    return (Ot(m, n) ? m : m.touches[0])[d];
  }
  function l(m) {
    return s = m, i = m, o(m);
  }
  function c(m) {
    const u = o(m) - o(i), S = e(m) - e(s) > 170;
    return i = m, S && (s = m), u;
  }
  function a(m) {
    if (!s || !i) return 0;
    const u = o(i) - o(s), S = e(m) - e(s), d = e(m) - e(i) > 170, p = u / S;
    return S && !d && _(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: l,
    pointerMove: c,
    pointerUp: a,
    readPoint: o
  };
}
function Pn() {
  function t(r) {
    const {
      offsetTop: s,
      offsetLeft: i,
      offsetWidth: e,
      offsetHeight: o
    } = r;
    return {
      top: s,
      right: i + e,
      bottom: s + o,
      left: i,
      width: e,
      height: o
    };
  }
  return {
    measure: t
  };
}
function wn(t) {
  function n(s) {
    return t * (s / 100);
  }
  return {
    measure: n
  };
}
function On(t, n, r, s, i, e, o) {
  const l = [t].concat(s);
  let c, a, y = [], m = !1;
  function u(h) {
    return i.measureSize(o.measure(h));
  }
  function S(h) {
    if (!e) return;
    a = u(t), y = s.map(u);
    function f(g) {
      for (const x of g) {
        if (m) return;
        const I = x.target === t, N = s.indexOf(x.target), E = I ? a : y[N], C = u(I ? t : s[N]);
        if (_(C - E) >= 0.5) {
          h.reInit(), n.emit("resize");
          break;
        }
      }
    }
    c = new ResizeObserver((g) => {
      (bt(e) || e(h, g)) && f(g);
    }), r.requestAnimationFrame(() => {
      l.forEach((g) => c.observe(g));
    });
  }
  function d() {
    m = !0, c && c.disconnect();
  }
  return {
    init: S,
    destroy: d
  };
}
function _n(t, n, r, s, i, e) {
  let o = 0, l = 0, c = i, a = e, y = t.get(), m = 0;
  function u() {
    const E = s.get() - t.get(), C = !c;
    let v = 0;
    return C ? (o = 0, r.set(s), t.set(s), v = E) : (r.set(t), o += E / c, o *= a, y += o, t.add(o), v = y - m), l = At(v), m = y, N;
  }
  function S() {
    const E = s.get() - n.get();
    return _(E) < 1e-3;
  }
  function d() {
    return c;
  }
  function p() {
    return l;
  }
  function h() {
    return o;
  }
  function f() {
    return x(i);
  }
  function g() {
    return I(e);
  }
  function x(E) {
    return c = E, N;
  }
  function I(E) {
    return a = E, N;
  }
  const N = {
    direction: p,
    duration: d,
    velocity: h,
    seek: u,
    settled: S,
    useBaseFriction: g,
    useBaseDuration: f,
    useFriction: I,
    useDuration: x
  };
  return N;
}
function Tn(t, n, r, s, i) {
  const e = i.measure(10), o = i.measure(50), l = ot(0.1, 0.99);
  let c = !1;
  function a() {
    return !(c || !t.reachedAny(r.get()) || !t.reachedAny(n.get()));
  }
  function y(S) {
    if (!a()) return;
    const d = t.reachedMin(n.get()) ? "min" : "max", p = _(t[d] - n.get()), h = r.get() - n.get(), f = l.constrain(p / o);
    r.subtract(h * f), !S && _(h) < e && (r.set(t.constrain(r.get())), s.useDuration(25).useBaseFriction());
  }
  function m(S) {
    c = !S;
  }
  return {
    shouldConstrain: a,
    constrain: y,
    toggleActive: m
  };
}
function An(t, n, r, s, i) {
  const e = ot(-n + t, 0), o = m(), l = y(), c = u();
  function a(d, p) {
    return dt(d, p) <= 1;
  }
  function y() {
    const d = o[0], p = H(o), h = o.lastIndexOf(d), f = o.indexOf(p) + 1;
    return ot(h, f);
  }
  function m() {
    return r.map((d, p) => {
      const {
        min: h,
        max: f
      } = e, g = e.constrain(d), x = !p, I = Dt(r, p);
      return x ? f : I || a(h, g) ? h : a(f, g) ? f : g;
    }).map((d) => parseFloat(d.toFixed(3)));
  }
  function u() {
    if (n <= t + i) return [e.max];
    if (s === "keepSnaps") return o;
    const {
      min: d,
      max: p
    } = l;
    return o.slice(d, p);
  }
  return {
    snapsContained: c,
    scrollContainLimit: l
  };
}
function Dn(t, n, r) {
  const s = n[0], i = r ? s - t : H(n);
  return {
    limit: ot(i, s)
  };
}
function zn(t, n, r, s) {
  const e = n.min + 0.1, o = n.max + 0.1, {
    reachedMin: l,
    reachedMax: c
  } = ot(e, o);
  function a(u) {
    return u === 1 ? c(r.get()) : u === -1 ? l(r.get()) : !1;
  }
  function y(u) {
    if (!a(u)) return;
    const S = t * (u * -1);
    s.forEach((d) => d.add(S));
  }
  return {
    loop: y
  };
}
function Bn(t) {
  const {
    max: n,
    length: r
  } = t;
  function s(e) {
    const o = e - n;
    return r ? o / -r : 0;
  }
  return {
    get: s
  };
}
function Vn(t, n, r, s, i) {
  const {
    startEdge: e,
    endEdge: o
  } = t, {
    groupSlides: l
  } = i, c = m().map(n.measure), a = u(), y = S();
  function m() {
    return l(s).map((p) => H(p)[o] - p[0][e]).map(_);
  }
  function u() {
    return s.map((p) => r[e] - p[e]).map((p) => -_(p));
  }
  function S() {
    return l(a).map((p) => p[0]).map((p, h) => p + c[h]);
  }
  return {
    snaps: a,
    snapsAligned: y
  };
}
function Mn(t, n, r, s, i, e) {
  const {
    groupSlides: o
  } = i, {
    min: l,
    max: c
  } = s, a = y();
  function y() {
    const u = o(e), S = !t || n === "keepSnaps";
    return r.length === 1 ? [e] : S ? u : u.slice(l, c).map((d, p, h) => {
      const f = !p, g = Dt(h, p);
      if (f) {
        const x = H(h[0]) + 1;
        return Jt(x);
      }
      if (g) {
        const x = yt(e) - H(h)[0] + 1;
        return Jt(x, H(h)[0]);
      }
      return d;
    });
  }
  return {
    slideRegistry: a
  };
}
function kn(t, n, r, s, i) {
  const {
    reachedAny: e,
    removeOffset: o,
    constrain: l
  } = s;
  function c(d) {
    return d.concat().sort((p, h) => _(p) - _(h))[0];
  }
  function a(d) {
    const p = t ? o(d) : l(d), h = n.map((g, x) => ({
      diff: y(g - p, 0),
      index: x
    })).sort((g, x) => _(g.diff) - _(x.diff)), {
      index: f
    } = h[0];
    return {
      index: f,
      distance: p
    };
  }
  function y(d, p) {
    const h = [d, d + r, d - r];
    if (!t) return d;
    if (!p) return c(h);
    const f = h.filter((g) => At(g) === p);
    return f.length ? c(f) : H(h) - r;
  }
  function m(d, p) {
    const h = n[d] - i.get(), f = y(h, p);
    return {
      index: d,
      distance: f
    };
  }
  function u(d, p) {
    const h = i.get() + d, {
      index: f,
      distance: g
    } = a(h), x = !t && e(h);
    if (!p || x) return {
      index: f,
      distance: d
    };
    const I = n[f] - g, N = d + y(I, 0);
    return {
      index: f,
      distance: N
    };
  }
  return {
    byDistance: u,
    byIndex: m,
    shortcut: y
  };
}
function Fn(t, n, r, s, i, e, o) {
  function l(m) {
    const u = m.distance, S = m.index !== n.get();
    e.add(u), u && (s.duration() ? t.start() : (t.update(), t.render(1), t.update())), S && (r.set(n.get()), n.set(m.index), o.emit("select"));
  }
  function c(m, u) {
    const S = i.byDistance(m, u);
    l(S);
  }
  function a(m, u) {
    const S = n.clone().set(m), d = i.byIndex(S.get(), u);
    l(d);
  }
  return {
    distance: c,
    index: a
  };
}
function Hn(t, n, r, s, i, e, o, l) {
  const c = {
    passive: !0,
    capture: !0
  };
  let a = 0;
  function y(S) {
    if (!l) return;
    function d(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - a > 10) return;
      o.emit("slideFocusStart"), t.scrollLeft = 0;
      const g = r.findIndex((x) => x.includes(p));
      Tt(g) && (i.useDuration(0), s.index(g, 0), o.emit("slideFocus"));
    }
    e.add(document, "keydown", m, !1), n.forEach((p, h) => {
      e.add(p, "focus", (f) => {
        (bt(l) || l(S, f)) && d(h);
      }, c);
    });
  }
  function m(S) {
    S.code === "Tab" && (a = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: y
  };
}
function ft(t) {
  let n = t;
  function r() {
    return n;
  }
  function s(c) {
    n = o(c);
  }
  function i(c) {
    n += o(c);
  }
  function e(c) {
    n -= o(c);
  }
  function o(c) {
    return Tt(c) ? c : c.get();
  }
  return {
    get: r,
    set: s,
    add: i,
    subtract: e
  };
}
function nn(t, n) {
  const r = t.scroll === "x" ? o : l, s = n.style;
  let i = null, e = !1;
  function o(u) {
    return `translate3d(${u}px,0px,0px)`;
  }
  function l(u) {
    return `translate3d(0px,${u}px,0px)`;
  }
  function c(u) {
    if (e) return;
    const S = Cn(t.direction(u));
    S !== i && (s.transform = r(S), i = S);
  }
  function a(u) {
    e = !u;
  }
  function y() {
    e || (s.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: y,
    to: c,
    toggleActive: a
  };
}
function Rn(t, n, r, s, i, e, o, l, c) {
  const y = mt(i), m = mt(i).reverse(), u = f().concat(g());
  function S(C, v) {
    return C.reduce((L, A) => L - i[A], v);
  }
  function d(C, v) {
    return C.reduce((L, A) => S(L, v) > 0 ? L.concat([A]) : L, []);
  }
  function p(C) {
    return e.map((v, L) => ({
      start: v - s[L] + 0.5 + C,
      end: v + n - 0.5 + C
    }));
  }
  function h(C, v, L) {
    const A = p(v);
    return C.map((P) => {
      const M = L ? 0 : -r, R = L ? r : 0, j = L ? "end" : "start", G = A[P][j];
      return {
        index: P,
        loopPoint: G,
        slideLocation: ft(-1),
        translate: nn(t, c[P]),
        target: () => l.get() > G ? M : R
      };
    });
  }
  function f() {
    const C = o[0], v = d(m, C);
    return h(v, r, !1);
  }
  function g() {
    const C = n - o[0] - 1, v = d(y, C);
    return h(v, -r, !0);
  }
  function x() {
    return u.every(({
      index: C
    }) => {
      const v = y.filter((L) => L !== C);
      return S(v, n) <= 0.1;
    });
  }
  function I() {
    u.forEach((C) => {
      const {
        target: v,
        translate: L,
        slideLocation: A
      } = C, P = v();
      P !== A.get() && (L.to(P), A.set(P));
    });
  }
  function N() {
    u.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: x,
    clear: N,
    loop: I,
    loopPoints: u
  };
}
function jn(t, n, r) {
  let s, i = !1;
  function e(c) {
    if (!r) return;
    function a(y) {
      for (const m of y)
        if (m.type === "childList") {
          c.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    s = new MutationObserver((y) => {
      i || (bt(r) || r(c, y)) && a(y);
    }), s.observe(t, {
      childList: !0
    });
  }
  function o() {
    s && s.disconnect(), i = !0;
  }
  return {
    init: e,
    destroy: o
  };
}
function Gn(t, n, r, s) {
  const i = {};
  let e = null, o = null, l, c = !1;
  function a() {
    l = new IntersectionObserver((d) => {
      c || (d.forEach((p) => {
        const h = n.indexOf(p.target);
        i[h] = p;
      }), e = null, o = null, r.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: s
    }), n.forEach((d) => l.observe(d));
  }
  function y() {
    l && l.disconnect(), c = !0;
  }
  function m(d) {
    return pt(i).reduce((p, h) => {
      const f = parseInt(h), {
        isIntersecting: g
      } = i[f];
      return (d && g || !d && !g) && p.push(f), p;
    }, []);
  }
  function u(d = !0) {
    if (d && e) return e;
    if (!d && o) return o;
    const p = m(d);
    return d && (e = p), d || (o = p), p;
  }
  return {
    init: a,
    destroy: y,
    get: u
  };
}
function qn(t, n, r, s, i, e) {
  const {
    measureSize: o,
    startEdge: l,
    endEdge: c
  } = t, a = r[0] && i, y = d(), m = p(), u = r.map(o), S = h();
  function d() {
    if (!a) return 0;
    const g = r[0];
    return _(n[l] - g[l]);
  }
  function p() {
    if (!a) return 0;
    const g = e.getComputedStyle(H(s));
    return parseFloat(g.getPropertyValue(`margin-${c}`));
  }
  function h() {
    return r.map((g, x, I) => {
      const N = !x, E = Dt(I, x);
      return N ? u[x] + y : E ? u[x] + m : I[x + 1][l] - g[l];
    }).map(_);
  }
  return {
    slideSizes: u,
    slideSizesWithGaps: S,
    startGap: y,
    endGap: m
  };
}
function $n(t, n, r, s, i, e, o, l, c) {
  const {
    startEdge: a,
    endEdge: y,
    direction: m
  } = t, u = Tt(r);
  function S(f, g) {
    return mt(f).filter((x) => x % g === 0).map((x) => f.slice(x, x + g));
  }
  function d(f) {
    return f.length ? mt(f).reduce((g, x, I) => {
      const N = H(g) || 0, E = N === 0, C = x === yt(f), v = i[a] - e[N][a], L = i[a] - e[x][y], A = !s && E ? m(o) : 0, P = !s && C ? m(l) : 0, M = _(L - P - (v + A));
      return I && M > n + c && g.push(x), C && g.push(f.length), g;
    }, []).map((g, x, I) => {
      const N = Math.max(I[x - 1] || 0);
      return f.slice(N, g);
    }) : [];
  }
  function p(f) {
    return u ? S(f, r) : d(f);
  }
  return {
    groupSlides: p
  };
}
function Kn(t, n, r, s, i, e, o) {
  const {
    align: l,
    axis: c,
    direction: a,
    startIndex: y,
    loop: m,
    duration: u,
    dragFree: S,
    dragThreshold: d,
    inViewThreshold: p,
    slidesToScroll: h,
    skipSnaps: f,
    containScroll: g,
    watchResize: x,
    watchSlides: I,
    watchDrag: N,
    watchFocus: E
  } = e, C = 2, v = Pn(), L = v.measure(n), A = r.map(v.measure), P = En(c, a), M = P.measureSize(L), R = wn(M), j = vn(l, M), G = !m && !!g, tt = m || !!g, {
    slideSizes: Z,
    slideSizesWithGaps: K,
    startGap: U,
    endGap: it
  } = qn(P, L, A, r, tt, i), q = $n(P, M, h, m, L, A, U, it, C), {
    snaps: rt,
    snapsAligned: st
  } = Vn(P, j, L, A, q), Q = -H(rt) + H(K), {
    snapsContained: ut,
    scrollContainLimit: lt
  } = An(M, Q, st, g, C), k = G ? ut : st, {
    limit: B
  } = Dn(Q, k, m), J = tn(yt(k), y, m), F = J.clone(), O = mt(r), b = ({
    dragHandler: ct,
    scrollBody: Lt,
    scrollBounds: Nt,
    options: {
      loop: St
    }
  }) => {
    St || Nt.constrain(ct.pointerDown()), Lt.seek();
  }, w = ({
    scrollBody: ct,
    translate: Lt,
    location: Nt,
    offsetLocation: St,
    previousLocation: sn,
    scrollLooper: cn,
    slideLooper: un,
    dragHandler: ln,
    animation: an,
    eventHandler: kt,
    scrollBounds: fn,
    options: {
      loop: Ft
    }
  }, Ht) => {
    const Rt = ct.settled(), dn = !fn.shouldConstrain(), jt = Ft ? Rt : Rt && dn, Gt = jt && !ln.pointerDown();
    Gt && an.stop();
    const mn = Nt.get() * Ht + sn.get() * (1 - Ht);
    St.set(mn), Ft && (cn.loop(ct.direction()), un.loop()), Lt.to(St.get()), Gt && kt.emit("settle"), jt || kt.emit("scroll");
  }, D = In(s, i, () => b(Et), (ct) => w(Et, ct)), V = 0.68, $ = k[J.get()], X = ft($), nt = ft($), W = ft($), et = ft($), at = _n(X, W, nt, et, u, V), vt = kn(m, k, Q, B, et), It = Fn(D, J, F, at, vt, et, o), Bt = Bn(B), Vt = gt(), on = Gn(n, r, o, p), {
    slideRegistry: Mt
  } = Mn(G, g, k, lt, q, O), rn = Hn(t, r, Mt, It, at, Vt, o, E), Et = {
    ownerDocument: s,
    ownerWindow: i,
    eventHandler: o,
    containerRect: L,
    slideRects: A,
    animation: D,
    axis: P,
    dragHandler: Ln(P, t, s, i, et, Nn(P, i), X, D, It, at, vt, J, o, R, S, d, f, V, N),
    eventStore: Vt,
    percentOfView: R,
    index: J,
    indexPrevious: F,
    limit: B,
    location: X,
    offsetLocation: W,
    previousLocation: nt,
    options: e,
    resizeHandler: On(n, o, i, r, P, x, v),
    scrollBody: at,
    scrollBounds: Tn(B, W, et, at, R),
    scrollLooper: zn(Q, B, W, [X, W, nt, et]),
    scrollProgress: Bt,
    scrollSnapList: k.map(Bt.get),
    scrollSnaps: k,
    scrollTarget: vt,
    scrollTo: It,
    slideLooper: Rn(P, M, Q, Z, K, rt, k, W, r),
    slideFocus: rn,
    slidesHandler: jn(n, o, I),
    slidesInView: on,
    slideIndexes: O,
    slideRegistry: Mt,
    slidesToScroll: q,
    target: et,
    translate: nn(P, n)
  };
  return Et;
}
function Un() {
  let t = {}, n;
  function r(a) {
    n = a;
  }
  function s(a) {
    return t[a] || [];
  }
  function i(a) {
    return s(a).forEach((y) => y(n, a)), c;
  }
  function e(a, y) {
    return t[a] = s(a).concat([y]), c;
  }
  function o(a, y) {
    return t[a] = s(a).filter((m) => m !== y), c;
  }
  function l() {
    t = {};
  }
  const c = {
    init: r,
    emit: i,
    off: o,
    on: e,
    clear: l
  };
  return c;
}
const Qn = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Jn(t) {
  function n(e, o) {
    return Wt(e, o || {});
  }
  function r(e) {
    const o = e.breakpoints || {}, l = pt(o).filter((c) => t.matchMedia(c).matches).map((c) => o[c]).reduce((c, a) => n(c, a), {});
    return n(e, l);
  }
  function s(e) {
    return e.map((o) => pt(o.breakpoints || {})).reduce((o, l) => o.concat(l), []).map(t.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: r,
    optionsMediaQueries: s
  };
}
function Xn(t) {
  let n = [];
  function r(e, o) {
    return n = o.filter(({
      options: l
    }) => t.optionsAtMedia(l).active !== !1), n.forEach((l) => l.init(e, t)), o.reduce((l, c) => Object.assign(l, {
      [c.name]: c
    }), {});
  }
  function s() {
    n = n.filter((e) => e.destroy());
  }
  return {
    init: r,
    destroy: s
  };
}
function xt(t, n, r) {
  const s = t.ownerDocument, i = s.defaultView, e = Jn(i), o = Xn(e), l = gt(), c = Un(), {
    mergeOptions: a,
    optionsAtMedia: y,
    optionsMediaQueries: m
  } = e, {
    on: u,
    off: S,
    emit: d
  } = c, p = P;
  let h = !1, f, g = a(Qn, xt.globalOptions), x = a(g), I = [], N, E, C;
  function v() {
    const {
      container: O,
      slides: b
    } = x;
    E = (wt(O) ? t.querySelector(O) : O) || t.children[0];
    const D = wt(b) ? E.querySelectorAll(b) : b;
    C = [].slice.call(D || E.children);
  }
  function L(O) {
    const b = Kn(t, E, C, s, i, O, c);
    if (O.loop && !b.slideLooper.canLoop()) {
      const w = Object.assign({}, O, {
        loop: !1
      });
      return L(w);
    }
    return b;
  }
  function A(O, b) {
    h || (g = a(g, O), x = y(g), I = b || I, v(), f = L(x), m([g, ...I.map(({
      options: w
    }) => w)]).forEach((w) => l.add(w, "change", P)), x.active && (f.translate.to(f.location.get()), f.animation.init(), f.slidesInView.init(), f.slideFocus.init(F), f.eventHandler.init(F), f.resizeHandler.init(F), f.slidesHandler.init(F), f.options.loop && f.slideLooper.loop(), E.offsetParent && C.length && f.dragHandler.init(F), N = o.init(F, I)));
  }
  function P(O, b) {
    const w = q();
    M(), A(a({
      startIndex: w
    }, O), b), c.emit("reInit");
  }
  function M() {
    f.dragHandler.destroy(), f.eventStore.clear(), f.translate.clear(), f.slideLooper.clear(), f.resizeHandler.destroy(), f.slidesHandler.destroy(), f.slidesInView.destroy(), f.animation.destroy(), o.destroy(), l.clear();
  }
  function R() {
    h || (h = !0, l.clear(), M(), c.emit("destroy"), c.clear());
  }
  function j(O, b, w) {
    !x.active || h || (f.scrollBody.useBaseFriction().useDuration(b === !0 ? 0 : x.duration), f.scrollTo.index(O, w || 0));
  }
  function G(O) {
    const b = f.index.add(1).get();
    j(b, O, -1);
  }
  function tt(O) {
    const b = f.index.add(-1).get();
    j(b, O, 1);
  }
  function Z() {
    return f.index.add(1).get() !== q();
  }
  function K() {
    return f.index.add(-1).get() !== q();
  }
  function U() {
    return f.scrollSnapList;
  }
  function it() {
    return f.scrollProgress.get(f.offsetLocation.get());
  }
  function q() {
    return f.index.get();
  }
  function rt() {
    return f.indexPrevious.get();
  }
  function st() {
    return f.slidesInView.get();
  }
  function Q() {
    return f.slidesInView.get(!1);
  }
  function ut() {
    return N;
  }
  function lt() {
    return f;
  }
  function k() {
    return t;
  }
  function B() {
    return E;
  }
  function J() {
    return C;
  }
  const F = {
    canScrollNext: Z,
    canScrollPrev: K,
    containerNode: B,
    internalEngine: lt,
    destroy: R,
    off: S,
    on: u,
    emit: d,
    plugins: ut,
    previousScrollSnap: rt,
    reInit: p,
    rootNode: k,
    scrollNext: G,
    scrollPrev: tt,
    scrollProgress: it,
    scrollSnapList: U,
    scrollTo: j,
    selectedScrollSnap: q,
    slideNodes: J,
    slidesInView: st,
    slidesNotInView: Q
  };
  return A(n, r), setTimeout(() => c.emit("init"), 0), F;
}
xt.globalOptions = void 0;
function zt(t = {}, n = []) {
  const r = qt(t), s = qt(n), [i, e] = $t(), [o, l] = $t(), c = pn(() => {
    i && i.reInit(r.current, s.current);
  }, [i]);
  return Pt(() => {
    _t(r.current, t) || (r.current = t, c());
  }, [t, c]), Pt(() => {
    xn(s.current, n) || (s.current = n, c());
  }, [n, c]), Pt(() => {
    if (Sn() && o) {
      xt.globalOptions = zt.globalOptions;
      const a = xt(o, r.current, s.current);
      return e(a), () => a.destroy();
    } else
      e(void 0);
  }, [o, e]), [l, i];
}
zt.globalOptions = void 0;
const Yn = "_carousel_1emul_1", Zn = "_carouselViewport_1emul_5", Wn = "_carouselContainer_1emul_9", te = "_carouselContainerHorizontal_1emul_13", ne = "_carouselContainerVertical_1emul_18", ee = "_carouselItem_1emul_23", oe = "_carouselItemHorizontal_1emul_30", re = "_carouselItemVertical_1emul_34", se = "_carouselControl_1emul_38", ce = "_carouselPreviousButtonHorizontal_1emul_49", ie = "_carouselNextButtonHorizontal_1emul_55", ue = "_carouselPreviousButtonVertical_1emul_61", le = "_carouselNextButtonVertical_1emul_67", ae = "_controlsOutside_1emul_73", fe = "_carouselControlIcon_1emul_86", de = "_srOnly_1emul_91", me = "_edgeFade_1emul_103", T = {
  carousel: Yn,
  carouselViewport: Zn,
  carouselContainer: Wn,
  carouselContainerHorizontal: te,
  carouselContainerVertical: ne,
  carouselItem: ee,
  carouselItemHorizontal: oe,
  carouselItemVertical: re,
  carouselControl: se,
  carouselPreviousButtonHorizontal: ce,
  carouselNextButtonHorizontal: ie,
  carouselPreviousButtonVertical: ue,
  carouselNextButtonVertical: le,
  controlsOutside: ae,
  carouselControlIcon: fe,
  srOnly: de,
  edgeFade: me
}, en = z.createContext(null);
function Ct() {
  const t = z.useContext(en);
  if (!t)
    throw new Error("useCarousel must be used within a <Carousel />");
  return t;
}
const pe = z.forwardRef(
  ({
    children: t,
    className: n,
    controlsPosition: r = "inside",
    edgeFade: s = !1,
    hideControlsAtEnds: i = !1,
    opts: e,
    orientation: o = "horizontal",
    plugins: l,
    setApi: c,
    ...a
  }, y) => {
    const [m, u] = zt(
      {
        ...e,
        axis: o === "horizontal" ? "x" : "y"
      },
      l
    ), [S, d] = z.useState(!1), [p, h] = z.useState(!1), f = !!(e != null && e.dragFree) && !(e != null && e.loop), g = z.useCallback(
      (C) => {
        if (C) {
          if (f) {
            const v = C.scrollSnapList().length > 1, L = C.scrollProgress();
            d(v && L > 1e-3), h(v && L < 0.999);
            return;
          }
          d(C.canScrollPrev()), h(C.canScrollNext());
        }
      },
      [f]
    ), x = z.useCallback(() => {
      u == null || u.scrollPrev();
    }, [u]), I = z.useCallback(() => {
      u == null || u.scrollNext();
    }, [u]), N = z.useCallback(
      (C) => {
        C.key === "ArrowLeft" ? (C.preventDefault(), x()) : C.key === "ArrowRight" && (C.preventDefault(), I());
      },
      [x, I]
    );
    z.useEffect(() => {
      !u || !c || c(u);
    }, [u, c]), z.useEffect(() => {
      if (u)
        return g(u), u.on("reInit", g), u.on("select", g), f && u.on("scroll", g), () => {
          u == null || u.off("reInit", g), u == null || u.off("select", g), u == null || u.off("scroll", g);
        };
    }, [u, g, f]);
    const E = z.useMemo(
      () => ({
        carouselRef: m,
        api: u,
        opts: e,
        orientation: o || ((e == null ? void 0 : e.axis) === "y" ? "vertical" : "horizontal"),
        scrollPrev: x,
        scrollNext: I,
        canScrollPrev: S,
        canScrollNext: p,
        hideControlsAtEnds: i
      }),
      [m, u, e, o, x, I, S, p, i]
    );
    return /* @__PURE__ */ Y(en.Provider, { value: E, children: /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "carousel",
        className: ht(
          T.carousel,
          r === "outside" && T.controlsOutside,
          s && o === "horizontal" && T.edgeFade,
          n
        ),
        "data-can-scroll-next": p,
        "data-can-scroll-prev": S,
        "data-cxy-name": "carousel",
        onKeyDownCapture: N,
        ref: y,
        role: "region",
        ...a,
        children: t
      }
    ) });
  }
);
pe.displayName = "Carousel";
const ge = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { carouselRef: s, orientation: i } = Ct();
    return /* @__PURE__ */ Y("div", { className: T.carouselViewport, ref: s, children: /* @__PURE__ */ Y(
      "div",
      {
        className: ht(
          T.carouselContainer,
          i === "horizontal" ? T.carouselContainerHorizontal : T.carouselContainerVertical,
          t
        ),
        ref: r,
        ...n
      }
    ) });
  }
);
ge.displayName = "CarouselContent";
const he = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { orientation: s } = Ct();
    return /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "slide",
        className: ht(
          T.carouselItem,
          s === "horizontal" ? T.carouselItemHorizontal : T.carouselItemVertical,
          t
        ),
        ref: r,
        role: "group",
        ...n
      }
    );
  }
);
he.displayName = "CarouselItem";
const ye = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...s }, i) => {
    const { canScrollPrev: e, hideControlsAtEnds: o, orientation: l, scrollPrev: c } = Ct();
    return o && !e ? null : /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          T.carouselControl,
          T.carouselPreviousButton,
          l === "horizontal" ? T.carouselPreviousButtonHorizontal : T.carouselPreviousButtonVertical,
          t
        ),
        disabled: !e,
        onClick: c,
        ref: i,
        size: n,
        variant: r,
        ...s,
        children: [
          /* @__PURE__ */ Y(gn, { className: T.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: T.srOnly, children: "Previous slide" })
        ]
      }
    );
  }
);
ye.displayName = "CarouselPrevious";
const Se = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...s }, i) => {
    const { canScrollNext: e, hideControlsAtEnds: o, orientation: l, scrollNext: c } = Ct();
    return o && !e ? null : /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          T.carouselControl,
          T.carouselNextButton,
          l === "horizontal" ? T.carouselNextButtonHorizontal : T.carouselNextButtonVertical,
          t
        ),
        disabled: !e,
        onClick: c,
        ref: i,
        size: n,
        variant: r,
        ...s,
        children: [
          /* @__PURE__ */ Y(hn, { className: T.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: T.srOnly, children: "Next slide" })
        ]
      }
    );
  }
);
Se.displayName = "CarouselNext";
export {
  pe as Carousel,
  ge as CarouselContent,
  he as CarouselItem,
  Se as CarouselNext,
  ye as CarouselPrevious
};
